import ItemUpah from './RegistrasiUpah';

export default ItemUpah;
